import React from 'react';
import PropTypes from 'prop-types';

import '../styles/Scale.css';

const Scale = ({parent, rowAmount, listLength, listItemIndex}) => {
    //Create styles for scale based on SubList size
     const scaleHeight = Math.floor(rowAmount*100/listLength);
     const scaleTopPosition = listItemIndex !== -1 ? Math.floor(listItemIndex * ((100-scaleHeight)/listLength)) : 0;
     //const scaleTopPosition = Math.floor(listItemIndex * ((100-scaleHeight)/listLength));
   
     let scaleStyle = {
       height: `${scaleHeight}%`,
       top: `${scaleTopPosition}%`,
     };

    return (
        <div className={`${parent}-scale`}>
            <div className="Scale-inner">
                <div className="Scale-amount" style={scaleStyle}></div>
            </div>
        </div>
    );
};

Scale.propTypes = {
    parent: PropTypes.string.isRequired,
    rowAmount: PropTypes.number.isRequired,
    listLength: PropTypes.number.isRequired,
    listItemIndex: PropTypes.number.isRequired,
}

export default Scale;